import { mapActions, mapGetters } from "vuex";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
  name: "delivery-payment",
  mixins: [dynamicsHead],
  computed: {
    ...mapGetters({
      delivery: "pages/page",
    }),
  },
  watch: {
    async $route() {
      await this.fetchDeliveryPage("delivery-and-payment");
      this.setPageMetaInfo(this.delivery)
    },
  },
  async created() {
    await this.fetchDeliveryPage("delivery-and-payment");
    this.setPageMetaInfo(this.delivery)
  },
  methods: {
    ...mapActions({
      fetchDeliveryPage: "pages/GET_PAGE",
    }),
  },
};
